import React, { ReactElement } from 'react';

interface GrayCardHeaderProps {
  header: string;
  subHeader?: string;
}

export function GrayCardHeader({
  header,
  subHeader,
}: GrayCardHeaderProps): ReactElement {
  return (
    <>
      <div className="text-7 pb-1 font-semibold">{header}</div>
      {subHeader && (
        <div className="text-3 font-normal text-gray-70">{subHeader}</div>
      )}
    </>
  );
}
